import { c as _c } from "react/compiler-runtime";
import { ChartData, Chart as ChartJS } from 'chart.js';
import ChartBox from 'modules/main/components/chart-box-section/chart-box';
import ChartsSkeleton from 'modules/main/components/chart-box-section/charts-skeleton';
import { ChartBoxSectionProps } from 'modules/main/components/chart-box-section/types';
import { useMain } from 'modules/main/hooks/use-main';
import { useRouter } from 'next/router';
import { MouseEvent, useEffect, useMemo, useRef, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { barChartOptions, withTooltipTitles } from 'shared/components/chart/chart-config';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { toFullDate, toShortDate } from 'shared/utils/date-time-format';
export interface LeadsChartBoxProps extends ChartBoxSectionProps {}
export const LeadsChartBox = t0 => {
  const $ = _c(22);
  const {
    filter
  } = t0;
  const chartRef = useRef(null);
  const {
    t
  } = useLocoTranslation();
  const {
    leads
  } = useMain(filter);
  const {
    user,
    intlLocale
  } = useUser();
  const router = useRouter();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      labels: [],
      datasets: []
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [leadsData, setLeadsData] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = event => chartRef.current?.getElementsAtEventForMode(event as unknown as Event, "index", {
      intersect: false
    }, true).at(0)?.index;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const getHoveredIndex = t2;
  let t3;
  if ($[2] !== intlLocale || $[3] !== leads?.values) {
    t3 = withTooltipTitles(barChartOptions, leads?.values.map(t4 => {
      const {
        date
      } = t4;
      return toFullDate(date, intlLocale);
    }) ?? []);
    $[2] = intlLocale;
    $[3] = leads?.values;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const options = t3;
  let t4;
  if ($[5] !== leads || $[6] !== router || $[7] !== user) {
    t4 = event_0 => {
      const index = getHoveredIndex(event_0);
      if (index === undefined) {
        return;
      }
      if (user && leads) {
        router.push(`/contacts?filter=%5B%7B"searchValue"%3A"${leads.values[index]?.date}T00%3A00%3A00"%2C"compareOperation"%3A"EQUALS"%2C"searchField"%3A"created_at"%7D%5D`);
      }
    };
    $[5] = leads;
    $[6] = router;
    $[7] = user;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const onClick = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = event_1 => {
      if (chartRef.current) {
        chartRef.current.canvas.style.cursor = getHoveredIndex(event_1) === undefined ? "default" : "pointer";
      }
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const onPointerMove = t5;
  let t6;
  let t7;
  if ($[10] !== intlLocale || $[11] !== leads) {
    t6 = () => {
      if (leads) {
        setLeadsData({
          labels: leads.values.map(value => toShortDate(value.date, intlLocale)),
          datasets: [{
            data: leads.values.map(_temp)
          }]
        });
      }
    };
    t7 = [intlLocale, leads];
    $[10] = intlLocale;
    $[11] = leads;
    $[12] = t6;
    $[13] = t7;
  } else {
    t6 = $[12];
    t7 = $[13];
  }
  useEffect(t6, t7);
  let t8;
  if ($[14] !== filter || $[15] !== intlLocale || $[16] !== leads || $[17] !== leadsData || $[18] !== onClick || $[19] !== options || $[20] !== t) {
    t8 = leads ? <ChartBox title={t("dashboard.main.new_leads")} total={new Intl.NumberFormat(intlLocale).format(leads.total)} diffPercents={leads.diffPercents} countDays={leads.countDays} dateSince={filter.dateSince} chart={<Bar ref={chartRef} onClick={onClick} onPointerMove={onPointerMove} height={200} data={leadsData} options={options} />} /> : <ChartsSkeleton />;
    $[14] = filter;
    $[15] = intlLocale;
    $[16] = leads;
    $[17] = leadsData;
    $[18] = onClick;
    $[19] = options;
    $[20] = t;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};
function _temp(t0) {
  const {
    value: value_0
  } = t0;
  return value_0;
}